<template>
  <el-dialog title="订单详情" :visible.sync="dialogVisible" width="1100px" class="order-info">
    <ul class="list">
      <li>
        <span>订单状态</span>
        <i>{{defData.pay_status_label}}</i>
      </li>
      <li>
        <span>订单号</span>
        <i>{{defData.order_number}}</i>
      </li>
      <li>
        <span>支付账号</span>
        <i>{{defData.username}}</i>
      </li>
      <li>
        <span>商品类型</span>
        <i>{{defData.object_type_label}}</i>
      </li>
      <li>
        <span>商品信息</span>
        <i>{{defData.name}}</i>
      </li>
      <li>
        <span>创建订单时间</span>
        <i>{{defData.create_time}}</i>
      </li>
      <li>
        <span>完成交易时间</span>
        <i>{{defData.pay_time || '一'}}</i>
      </li>
      <li>
        <span>应付金额</span>
        <i>{{defData.fee}}元</i>
      </li>
      <li>
        <span>实付金额</span>
        <i>{{defData.real_fee ? `${defData.real_fee}元` : ''}}</i>
      </li>
      <li>
        <span>折扣金额及详情</span>
        <i>{{defData.sign_up_reduction ? `${defData.sign_up_reduction}元` : ''}} {{defData.reason}}</i>
      </li>
      <li>
        <span>支付方式</span>
        <i>{{defData.pay_type_label || '一'}}</i>
      </li>
      <li>
        <span>提交退款时间</span>
        <i>{{defData.submission_time}}</i>
      </li>
      <li>
        <span>完成退款时间</span>
        <i>{{defData.refund_time}}</i>
      </li>
      <li>
        <span>退款金额</span>
        <i>{{defData.refund_fee ? `${defData.refund_fee}元` : ''}}</i>
      </li>
    </ul>
  </el-dialog>
</template>
<script>
import { Dialog } from 'element-ui';

export default {
  components: { ElDialog: Dialog },
  props: {
    defData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.order-info {
  .list {
    list-style: none;
    overflow: hidden;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 120px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
}
</style>
